export const VARIABLES = Symbol('__variables__');
export const INTERNAL_HOST_DISPATCH = Symbol('__internal_host_dispatch__');
export const EXISTING_SHADOW_ROOT_ON_CREATE = Symbol('__existing_shadow_root_on_create__');
